import { Dropdown, Form, InputOnChangeData } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import ErrorsView from "./ErrorsView";
import FileDropZone from "./common/FileDropZone";
import UserFiles from "./common/UserFiles";
import { UserFile } from "../models/UserFile";
import { Project } from "../models/Project";
import { useAppContext } from "../hooks/useAppContext";

export interface FormData {
  title: string;
  projectId: string;
  userFile?: UserFile;
}

interface Props {
  projects?: Project[] | null;
  formData: FormData;
  formErrors: FormError;
  errors: string[] | undefined;
  onChange: (formData: FormData) => void;
  onAcceptedFilesSelected: (userFiles: UserFile[]) => void;
  onRejectedFilesSelected: (userFiles: UserFile[]) => void;
}

const AddReferenceProcedureForm = ({
  projects,
  formData,
  formErrors,
  errors,
  onChange,
  onAcceptedFilesSelected,
  onRejectedFilesSelected,
}: Props) => {
  const { documentMaxSizeByte } = useAppContext();

  const handleChange = (e: any, { name, value }: InputOnChangeData) => {
    onChange({ ...formData, [name]: value });
  };

  return (
    <>
      <Form>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>Title</label>
            <Form.Input error={formErrors.title} name="title" value={formData.title} onChange={handleChange} />
          </Form.Field>
          <Form.Field
            clearable
            selection
            error={formErrors.projectId}
            control={Dropdown}
            name="projectId"
            value={formData.projectId}
            fluid
            label="Project"
            options={projects?.map((t) => ({ key: t.id, text: t.name, value: t.id }))}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field>
            <label>File</label>
            {formErrors.userFile && (
              <span className="field error">
                <label>{formErrors.userFile}</label>
              </span>
            )}
            <FileDropZone
              maxSizeByte={documentMaxSizeByte}
              multiple={false}
              accept={[".pdf"]}
              onAcceptedFilesSelected={onAcceptedFilesSelected}
              onRejectedFilesSelected={onRejectedFilesSelected}
            />
          </Form.Field>
        </Form.Group>

        {formData.userFile && (
          <Form.Group widths="equal">
            <Form.Field>
              <UserFiles userFilesMap={new Map([[formData.userFile.id, formData.userFile]])} />
            </Form.Field>
          </Form.Group>
        )}
      </Form>
      <ErrorsView errors={errors} />
    </>
  );
};

export default AddReferenceProcedureForm;
